<template>
    <svg
        width="30"
        height="23"
        viewBox="0 0 30 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M6.30906 1.24707H5.18871C4.57028 1.24707 4.06836 1.74603 4.06836 2.36083H7.42941C7.42941 1.74603 6.92749 1.24707 6.30906 1.24707Z"
            fill="currentColor"
        />
        <ellipse
            cx="15.2727"
            cy="12.3847"
            rx="5.60175"
            ry="5.5688"
            fill="currentColor"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M27.5964 3.47458H22.8193C21.97 3.47458 21.1947 2.99789 20.8149 2.24276L20.3735 1.36401C19.9937 0.60999 19.2173 0.133301 18.3692 0.133301H12.1759C11.3267 0.133301 10.5514 0.60999 10.1716 1.36512L9.73019 2.24388C9.35039 2.99789 8.57399 3.47458 7.72588 3.47458H2.94871C1.71072 3.47458 0.708008 4.4714 0.708008 5.7021V20.181C0.708008 21.4117 1.71072 22.4085 2.94871 22.4085H27.5964C28.8344 22.4085 29.8371 21.4117 29.8371 20.181V5.7021C29.8371 4.4714 28.8344 3.47458 27.5964 3.47458ZM15.2723 20.181C10.9477 20.181 7.42983 16.6838 7.42983 12.3847C7.42983 8.08558 10.9477 4.58837 15.2723 4.58837C19.5968 4.58837 23.1147 8.08558 23.1147 12.3847C23.1147 16.6838 19.5968 20.181 15.2723 20.181ZM24.2358 6.81593C24.2358 7.43072 24.7377 7.92969 25.3561 7.92969C25.9746 7.92969 26.4765 7.43072 26.4765 6.81593C26.4765 6.20113 25.9746 5.70217 25.3561 5.70217C24.7377 5.70217 24.2358 6.20113 24.2358 6.81593Z"
            fill="currentColor"
        />
    </svg>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "CameraSolidIcon",
    setup() {
        return {};
    },
});
</script>
